import styled from 'styled-components';

export const StyledUserPanelResults = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    min-height: 50px;
    margin-top: 8px;
`;
